<template>
    <div class="my">
        <div class="my_header">
            <van-skeleton title avatar :row="2" v-if="userInfo==''"/>
            <template v-else>
                <div>
                    <img :src="userInfo.avatar||'https://oss.mcloud.moveclub.cn/alphamovecloud/20220811/1660192482/373678.png'" alt="">
                    <div>
                        <span>{{userInfo.nickname}}</span>
                    </div>
                </div>
                <!-- <div>
                    <span>账号积分: </span>
                    <div>
                        <span><span>{{userInfo.point||userInfo.totalpoint}}</span></span>
                        <div class="mvbutton" @click="goexchange">去兑换</div>
                    </div>
                </div> -->

            </template>
        </div>
        <!-- <div class="tips"> 积分不够花?点击 <span @click="goindex">活动专区</span>,赚取积分吧!
        </div> -->
        <div class="my_body">
            <CellGroup v-for="(item,index) in links" :key="index">

                <Cell is-link :to="citem.to" size="large" v-for="(citem,cindex) in item"  :key="cindex">{{citem.name}}
                    <img :src="citem.src" alt="" slot="icon">
                </Cell>

            </CellGroup>
            <div class="cencel" @click="logout">退出登录</div>
        </div>
    </div>
</template>
<script>
    import './index.less'
    import {Cell, CellGroup} from 'vant'

    export default {
        data() {
            return {
                userInfo: '',
                links: [
                    [
                        {
                            'name': '评估记录',
                            'src': 'https://oss.mcloud.moveclub.cn/alphamovecloud/20220325/1648201820/73925.png',
                            'to': {name: 'matchindex'}
                        },
                        {
                            'name': '新建评估表(未填报赛事评估)',
                            'src': 'https://oss.mcloud.moveclub.cn/alphamovecloud/20220325/1648201820/192177.png',
                            'to': {name: 'joinMatch1'}
                        },
                    ],
                    // [
                    //     {
                    //         'name': '积分详情',
                    //         'src': 'https://oss.mcloud.moveclub.cn/alphamovecloud/20220325/1648201820/73925.png',
                    //         'to': {name: 'coinRecord'}
                    //     },
                    //     {
                    //         'name': '兑换记录',
                    //         'src': 'https://oss.mcloud.moveclub.cn/alphamovecloud/20220325/1648201820/192177.png',
                    //         'to': {name: 'myOrders'}
                    //     },
                    // ],
                    
                ]
            }
        },
        components: {
            Cell,
            CellGroup
        },
        methods: {
            goexchange() {
                this.$router.push({name: "exchange"});

            },
            goindex() {
                this.$router.push({name: "index"});

            },
            getUserInfo() {
                this.$api.user.getUserInfo().then((res) => {
                    if (res.success) {
                        this.userInfo = res.data
                    }
                })
            },
            logout() {
                window.localStorage.clear()
                this.$router.push({name: "login"});
            }
        },
        mounted() {
            this.getUserInfo()
        }
    }
</script>
